export default "__VITE_ASSET__CqiP9Cq5__"